import { render, staticRenderFns } from "./CmgGroupOrderCreatePage.vue?vue&type=template&id=ad6bd2fc&scoped=true&lang=pug&"
import script from "./cmg-group-order-create-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-group-order-create-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgGroupOrderCreatePage.vue?vue&type=style&index=0&id=ad6bd2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6bd2fc",
  null
  
)

export default component.exports